<template>
    <div  style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column;margin-bottom: 46px;">
        <van-nav-bar title="援助申请" left-arrow @click-left="onClickLeft" />
        <div
                :is="tabContent"
                :user-type="userTypes.customer"
                :open-id="$store.state.user.openId"
                @addassistance="onAddAssistance"
                style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll"
        ></div>
        <van-tabbar v-model="active">
            <van-tabbar-item  icon="home-o">新建</van-tabbar-item>
            <van-tabbar-item  icon="chat-o" >我的援助</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import AddAssistance from './AddAssistance'
    import AssistanceList from './AssistanceList';
    import {userTypes} from '../../common/const';
  export default {
    name: "CustomerAssistance",
    data() {
      return {
        active:0,
        userTypes:userTypes
      };
    },
    components: {
      AddAssistance,AssistanceList
    },
    computed:{
      tabContent(){
        if (this.active===0){
          return AddAssistance
        } else if(this.active === 1){
          return AssistanceList
        } else {
          return  AddAssistance
        }
      }
    },
    methods:{

      onClickLeft() {
        this.$router.back();
      },
      onAddAssistance() {
        this.active = 1;
      }
    }
  }
</script>

<style scoped>

</style>